import * as React from 'react';
import {Button, Divider, Modal, Table} from 'antd';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import FormattedDateTime from "@components/custom/FormattedDateTime";
import {Alias, AliasTypeOptions} from '@models/alias';
import Message from "@constants/message";
import {NavLink} from "react-router-dom";
import {PaginationDefaultParams} from "../custom/Paginator";


type Props = {
  data: Alias[];
  loading: boolean;
  deleteFn: (item: Alias) => void;
  intl: intlShape.isRequired;
  currentPage: number;
};


const AliasesTable: React.FC<Props> = props => {
  const {data, loading, currentPage, deleteFn, intl} = props;
  const {formatMessage} = intl;
  const pageOffset = (currentPage - 1) * PaginationDefaultParams.count;
  
  const deleteAlias = (item: Alias): void => {
    Modal.confirm({
      content: formatMessage({
        id: "app.general_delete_warning",
        defaultMessage: Message.Warning.Delete,
      }),
      okText: formatMessage({
        id: "app.delete",
        defaultMessage: "Delete",
      }),
      cancelText: formatMessage({
        id: "app.cancel",
        defaultMessage: "Cancel",
      }),
      className: "delete-confirm-dialog",
      onOk: () => deleteFn(item),
    });
  };
  
  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`}/>,
      width: 30,
      dataIndex: 'index',
      key: 'id',
      render: (a, b, i) => <span>{i + 1 + pageOffset}</span>
    },
    {
      title: <FormattedMessage id="app.name" defaultMessage={`Name`}/>,
      width: 150,
      dataIndex: 'text',
      key: 'text'
    },
    {
      title: <FormattedMessage id="app.type" defaultMessage={`Type`}/>,
      width: 150,
      dataIndex: 'type',
      key: 'type',
      render: type => {
        const obj = AliasTypeOptions.find(item => item.value == type);
        return obj ? obj.label : type;
      }
    },
    {
      title: <FormattedMessage id="app.creation_date" defaultMessage={`Creation Date`}/>,
      width: 120,
      dataIndex: 'created_at',
      key: 'created_at',
      render: (text, record) => <FormattedDateTime date={text}/>
    },
    {
      title: '',
      key: 'actions',
      width: 90,
      dataIndex: 'actions',
      render: (text, record) => (
        <span>
                 <NavLink to={`/aliases/${record.id}/edit`}>
                     <Button type="link" size={`small`}>
                         <FormattedMessage id="app.edit" defaultMessage={`Edit`}/>
                     </Button>
                 </NavLink>

                    <Divider type="vertical" size={`small`}/>

                    <Button type="link" className={`danger`} onClick={() => deleteAlias(record)}>
                      <FormattedMessage id="app.delete" defaultMessage={`Delete`}/>
                    </Button>
                </span>
      ),
    },
  ];
  
  
  return (
    <Table columns={columns}
           loading={loading}
           pagination={false}
           dataSource={data}
           rowKey='id'/>
  )
  
};

export default injectIntl(AliasesTable)